module.exports = __webpack_public_path__ + "img/bg-1.f96c74c3.jpg";